import React, { useState } from 'react'

import clsx from 'clsx'

import CtaButton from 'components/CtaButton'
import Grid from 'components/Grid'
import { useAppContext } from 'context/AppContext'
import { useEventContext } from 'context/EventContext'
import useViewport from 'hooks/useViewport'

import TextBase from '../TextBase'
import ProCon from './components/ProCon'
import Reviewers from './components/Reviewers'
import { CON, PRO } from './contants'

import classes from './ProsAndCons.module.scss'

/** @type {import("./types").default} */
const ProsAndCons = ({ title, text, pros, cons, reviewers, bxListing, className }) => {
  const {
    userAgent: { isBot },
  } = useAppContext()
  const { up } = useViewport()
  const eventContext = useEventContext()

  const isDesktop = up('lg')
  const [expandedLeft, setExpandedLeft] = useState(isBot)
  const [expandedRight, setExpandedRight] = useState(isBot)

  const prosVisible = expandedLeft ? pros : pros.slice(0, 3)
  const consVisible = expandedRight ? cons : cons.slice(0, 3)

  const onExpandAll = () => {
    setExpandedLeft(true)
    setExpandedRight(true)
  }

  const buttonEventProps = eventContext.addEvent({
    engagementComponent: 'product_pros-and-cons',
    engagementDetails: 'text-link_read-more-pros-cons',
    engagementDestination: 'expand',
    name: 'engagement_product_click',
  })

  return (
    <section className={clsx('ProsAndCons', className)}>
      <TextBase title={title} />

      <Grid spacing={3} container>
        <Grid item xs={12} sm={8}>
          <TextBase text={text} className={classes.text} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Reviewers reviewers={reviewers} totalReviewers={bxListing.textReviews.totalCount} />
        </Grid>
        <Grid item xs={12} lg={6} className={clsx(classes.columnLeft, { [classes.shrank]: !expandedLeft })}>
          <Grid container spacing={4}>
            {prosVisible.map(({ title, text }, index) => (
              <Grid xs={12} item key={`pro-${index}`}>
                <ProCon type={PRO} title={title} text={text} />
              </Grid>
            ))}
          </Grid>
        </Grid>
        {!isDesktop && !expandedLeft && (
          <Grid item xs={12} className={classes.readMore}>
            <CtaButton variant="outlined" size="small" onClick={() => setExpandedLeft(true)} {...buttonEventProps}>
              + READ MORE
            </CtaButton>
          </Grid>
        )}
        <Grid item xs={12} lg={6} className={clsx(classes.columnRight, { [classes.shrank]: !expandedRight })}>
          <Grid container spacing={3}>
            {consVisible.map(({ title, text }, index) => (
              <Grid xs={12} item key={`con-${index}`}>
                <ProCon type={CON} title={title} text={text} />
              </Grid>
            ))}
          </Grid>
        </Grid>
        {!expandedRight && (
          <Grid item xs={12} className={classes.readMore}>
            <CtaButton
              variant="outlined"
              size="small"
              onClick={isDesktop ? onExpandAll : () => setExpandedRight(true)}
              {...buttonEventProps}
            >
              + READ MORE
            </CtaButton>
          </Grid>
        )}
      </Grid>
    </section>
  )
}

export default ProsAndCons
